// src/Components/YearSelect.js
import React from 'react';

const SelectYear = ({ selectedYear, handleYearChange }) => {
  const currentYear = new Date().getFullYear();
  const startYear = 2023;

  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  return (
    <select id="year-select" value={selectedYear} onChange={(e) => handleYearChange(e.target.value)}>
      <option value="">Select Year</option>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default SelectYear;
